import React from "react";

function EmployeeDetails({ empDetails, clickView, clickEdit, clickStatus }) {
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        Employee Details
      </h6>
      <p className="mb-1">
        <strong>Name:</strong> {empDetails?.firstName} {empDetails?.middleName}{" "}
        {empDetails?.lastName}
      </p>
      <p className="mb-1">
        <strong>Position:</strong> {empDetails?.position}
      </p>
      <p className="mb-1">
        <strong>Date Hired:</strong> {empDetails?.dateHired || "Sept. 13, 2024"}
      </p>
      <p className="mb-1">
        <strong>Birthdate:</strong>{" "}
        {new Date(empDetails?.birthDate).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>
      <p className="mb-1">
        <strong>Age:</strong> {empDetails?.age}
      </p>

      <p className="mb-1">
        <strong>Phone Number:</strong> {empDetails?.mobileNumber}
      </p>

      {/* Buttons */}
      <div className="mt-3">
        <button
          className="btn text-white w-100"
          style={{ backgroundColor: "#d18237" }}
          onClick={() => clickView()}
        >
          View Employee
        </button>
      </div>
      <div className="d-flex justify-content-between mt-3">
        <button
          className="btn text-dark flex-grow-1 me-2"
          style={{ backgroundColor: "#e5e5e5" }}
          onClick={() => clickEdit()}
        >
          Edit
        </button>
        <button
          className="btn text-white flex-grow-1"
          style={{ backgroundColor: "#3f7cc0" }}
          onClick={() => clickStatus()}
        >
          Change Status
        </button>
      </div>
    </div>
  );
}

export default EmployeeDetails;
